import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatDialogModule } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { SvgIconsModule } from '@ngneat/svg-icon'
import { UserUiModule } from '@upkey-platform/accounts/user-frontend'
import { DirectivesModule } from '@upkey-platform/core/core-frontend'
import { UiModule } from '@upkey-platform/ui'
import { CarouselModule } from 'ngx-owl-carousel-o'
import { SharedModule } from '../../shared/shared.module'
import { AboutComponent } from './about/about.component'
import { CareerCreationCourseLandingComponent } from './career-creation-course-landing/career-creation-course-landing.component'
import { CareerCreationCourseCardComponent } from './career-creation-course-landing/components/career-creation-course-card/career-creation-course-card.component'
import { CourseMentorsCarouselComponent } from './career-creation-course-landing/components/course-mentors-carousel/course-mentors-carousel.component'
import { CccVideoPresentationModalComponent } from './career-creation-course-landing/modal/ccc-video-presentation-modal/ccc-video-presentation-modal.component'
import { CertificateComponent } from './certificate/certificate.component'
import { HomePageAwardsComponent } from './home/components/home-page-awards/home-page-awards.component'
import { HomePageHeroComponent } from './home/components/home-page-hero/home-page-hero.component'
import { HomePageTestimonialComponent } from './home/components/home-page-testimonial/home-page-testimonial.component'
import { HomePageUniversitiesComponent } from './home/components/home-page-universities/home-page-universities.component'
import { HomeScreenComponent } from './home/home.component'
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component'
import { PublicRoutingModule } from './public-routing.module'
import { SelfBrandingCourseCardComponent } from './self-branding-course-landing/components/self-branding-course-card/self-branding-course-card.component'
import { SelfBrandingHeroComponent } from './self-branding-course-landing/components/self-branding-hero/self-branding-hero.component'
import { SelfBrandingCourseLandingComponent } from './self-branding-course-landing/self-branding-course-landing/self-branding-course-landing.component'
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { HomePageExtensionSitesComponent } from './home/components/home-page-extension-sites/home-page-extension-sites.component'
import { HomeProjectClosedComponent } from './home/components/home-project-closed/home-project-closed.component'

@NgModule({
  declarations: [
    HomeScreenComponent,
    CertificateComponent,
    HomeProjectClosedComponent,
    HomePageHeroComponent,
    HomePageTestimonialComponent,
    CareerCreationCourseLandingComponent,
    CccVideoPresentationModalComponent,
    CareerCreationCourseCardComponent,
    CourseMentorsCarouselComponent,
    AboutComponent,
    TermsOfUseComponent,
    PrivacyPolicyComponent,
    SelfBrandingHeroComponent,
    SelfBrandingCourseCardComponent,
    SelfBrandingCourseLandingComponent,
    HomePageAwardsComponent,
    HomePageUniversitiesComponent,
    HomePageExtensionSitesComponent
  ],
  imports: [
    CommonModule,
    PublicRoutingModule,
    SvgIconsModule,
    UiModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatDialogModule,
    MatExpansionModule,
    CarouselModule,
    UserUiModule,
    DirectivesModule
  ],
  exports: [CertificateComponent]
})
export class PublicModule {}
